import { useQuery } from "@tanstack/react-query";
import { get } from "../components/utils/request";
import { useAuthStore } from "../stores/authStore";
const dataPropertiesSlug = async ({ slug, token }) => {
  const data = await get({
    path: `/client/properties/slug/${slug}`,
    token,
  });

  return data;
};

export const usePropertiesSlug = (slug, token = null) => {
  const { auth } = useAuthStore();
  const dataPropertiesSlugQuery = useQuery({
    queryKey: ["dataPropertiesSlug", slug],
    queryFn: () =>
      dataPropertiesSlug({
        slug,
        token: !token ? auth.accessToken : token,
      }),

    refetchInterval: 1000 * 60 * 5,
  });

  return {
    dataPropertiesSlugQuery,
  };
};
